<vehicle-type-switch-component [selectedValue]="selectedVehicleType" (selectedValueChange)="selectedVehicleTypeValueChange($event)"></vehicle-type-switch-component>
<div class="row" id="main-content">
  <div class="col-xl-12 col-sm-12 h-100">
    <div class="row h-100">
      <div class="col-sm-12 menu">
        <mat-form-field appearance="fill" style="width: 15%">
          <mat-label>Show</mat-label>
          <mat-select [(value)]="selectedShowMode" (selectionChange)="showModeChange($event.value)">
            <mat-option value={{ShowMode[ShowMode.All]}}>All</mat-option>
            <mat-option value={{ShowMode[ShowMode.NewOrders]}}>New contracts</mat-option>
            <mat-option value={{ShowMode[ShowMode.ContainerOnSite]}}>Container on site</mat-option>
            <mat-option value={{ShowMode[ShowMode.NoContainerOnSite]}}>No container on site</mat-option>
            <mat-option value={{ShowMode[ShowMode.OnlyDiscrepancies]}}>Discrepancies</mat-option>
            <mat-option value={{ShowMode[ShowMode.SlowMovers]}}>Slow Movers</mat-option>
            @if (isAdmin && showAdminOptions) {
              <mat-option value={{ShowMode[ShowMode.RecentlyUpdated]}}>Recently Updated</mat-option>
            }
            @if (isAdmin && showAdminOptions) {
              <mat-option value={{ShowMode[ShowMode.MissingCollection]}}>Missing Collection</mat-option>
            }
            @if (isAdmin && showAdminOptions) {
              <mat-option value={{ShowMode[ShowMode.MovedContract]}}>Moved Contract</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 12%">
          <mat-label>Depot</mat-label>
          <mat-select [(value)]="selectedDepotId" (selectionChange)="depotChange($event.value)">
            <mat-option value="">None</mat-option>
            @if (!depotList || depotList.length != 1) {
              <mat-option value="00000000-0000-0000-0000-000000000000">All</mat-option>
            }
            @for (depot of depotList; track depot) {
              <mat-option [value]="depot.id">{{depot.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" [hidden]="!showSubFilter || showSlowMovers" style="width: 12%">
          <mat-label>Contract status</mat-label>
          <mat-select [(value)]="selectedSubFilterId" (selectionChange)="subFilterChange($event.value)">
            <mat-option>None</mat-option>
            @for (subFilter of subFilterList; track subFilter) {
              <mat-option [value]="subFilter.id">{{subFilter.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" [hidden]="!showNewOrderDate || showSlowMovers" style="width: 12%">
          <mat-label>Contract date</mat-label>
          <input matInput [formControl]="orderFromDate" [matDatepicker]="picker" (dateChange)="dateFilterChanged($event.value)">
          <mat-datepicker-toggle matSuffix [for]="picker">
          </mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 9%">
          <mat-label>Type</mat-label>
          <mat-select [(value)]="selectedAssetTypeId" (selectionChange)="assetTypeChange($event.value)" [typeaheadDebounceInterval]="2000">
            <input class="dropDownSearch" [formControl]="assetTypeSearchControl">
            <mat-option>None</mat-option>
            @for (assetType of assetTypeList; track assetType) {
              <mat-option [value]="assetType.id">{{assetType.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" [hidden]="!showSlowMovers" style="width: 12%">
          <mat-label>Waste Stream</mat-label>
          <mat-select multiple [(value)]="selectedWasteTypeNames" (selectionChange)="wasteTypeChange($event.value)">
            @for (item of wasteTypeList; track item) {
              <mat-option [value]="item.id">{{item.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 12%" [hidden]="showSlowMovers">
          <mat-label>Contract</mat-label>
          <mat-select [(value)]="selectedExternalReference" (selectionChange)="agreementChange($event.value)" [typeaheadDebounceInterval]="2000">
            <input class="dropDownSearch" [formControl]="agreementSearchControl" (keyup)="onAgreementSearch($event.target.value)">
            <mat-option>None</mat-option>
            @for (externalReference of filteredAgreementList; track externalReference) {
              <mat-option [value]="externalReference.id">{{externalReference.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" [hidden]="!showSlowMovers || showWasteStream" style="width: 12%">
          <mat-label>Account Manager</mat-label>
          <mat-select [(value)]="selectedAccountManager" (selectionChange)="accountManagerChange($event.value)">
            <mat-option>None</mat-option>
            @for (item of accountManagerList; track item) {
              <mat-option [value]="item.id">{{item.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" [hidden]="!showSlowMovers || showLatestActionDate" style="width: 12%">
          <mat-label>Account Code</mat-label>
          <mat-select [(value)]="selectedAccountCode" (selectionChange)="accountCodeChange($event.value)">
            <mat-option>None</mat-option>
            @for (item of accountCodeList; track item) {
              <mat-option [value]="item.id">{{item.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" [hidden]="!showSlowMovers || !showAccountCategory || showLatestActionDescription" style="width: 13%">
          <mat-label>Account Category</mat-label>
          <mat-select [(value)]="selectedAccountCategory" (selectionChange)="accountCategoryChange($event.value)">
            <mat-option>None</mat-option>
            @for (item of accountCategoryList; track item) {
              <mat-option [value]="item.id">{{item.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" [hidden]="!showSlowMovers || !showAccountType" style="width: 13%">
          <mat-label>Account Type</mat-label>
          <mat-select [(value)]="selectedAccountType" (selectionChange)="accountTypeChange($event.value)">
            <mat-option>None</mat-option>
            @for (item of accountTypeList; track item) {
              <mat-option [value]="item.id">{{item.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" [hidden]="!showSlowMovers || showAccountCategory || showAccountType" style="width: 13%">
          <mat-label>Customer</mat-label>
          <mat-select [(value)]="selectedCustomer" (selectionChange)="customerChange($event.value)">
            <mat-option>None</mat-option>
            @for (item of customerList; track item) {
              <mat-option [value]="item.id">{{item.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 25%">
          <mat-label>Location</mat-label>
          <mat-select [(value)]="selectedAssetLocationId" (selectionChange)="locationChange($event.value)" [typeaheadDebounceInterval]="2000">
            <input class="dropDownSearch" [formControl]="locationSearchControl" (keyup)="onLocationSearch($event.target.value)">
            <mat-option>None</mat-option>
            @for (location of filteredLocationsList; track location) {
              <mat-option [value]="location.id">{{location.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 12%" [hidden]="showSlowMovers">
          <mat-label>Status</mat-label>
          <mat-select [(value)]="selectedContainerStatus" (selectionChange)="containerStatusChange($event.value)">
            <mat-option>None</mat-option>
            <mat-option value={{ContainerStatus[ContainerStatus.DifferentContainerSize]}}>Different Container Size</mat-option>
            <mat-option value={{ContainerStatus[ContainerStatus.DifferentContainerType]}}>Different Container Type</mat-option>
            <mat-option value={{ContainerStatus[ContainerStatus.DifferentWaste]}}>Different Waste</mat-option>
            <mat-option value={{ContainerStatus[ContainerStatus.Matched]}}>Matched</mat-option>
            <mat-option value={{ContainerStatus[ContainerStatus.NotMatched]}}>Not Matched</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-sm-12 results">
        @if (this.selectedDepotId === null) {
          <div id="message" class="pl-1">
            Please select a depot.
          </div>
        }

        @if (data?.agreements?.items && data.agreements.items.length > 0) {
          <div class="card mt-2">
            <div class="card-header">
              <div class="card-header-title">
              </div>
              @if (showSlowMovers) {
                <button  (click)="exportSlowMovers()" class="btn btn-white btn-sm">
                  Export Data
                  <span class="svg-icon svg-icon-xs ms-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><title>Export data</title><polyline points="268 112 412 256 268 400" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px"/><line x1="392" y1="256" x2="100" y2="256" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px"/></svg>
                  </span>
                </button>
              }
              @if (showContainerOnSite) {
                <button  (click)="exportContainersOnSite()" class="btn btn-white btn-sm">
                  Export Data
                  <span class="svg-icon svg-icon-xs ms-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><title>Export data</title><polyline points="268 112 412 256 268 400" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px"/><line x1="392" y1="256" x2="100" y2="256" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px"/></svg>
                  </span>
                </button>
              }
            </div>
            <div class="table-responsive">
              <table id="report" class='table table-sm card-table table-wrap' aria-labelledby="tableLabel">
                <thead>
                  <tr>
                    <th class="default sortableColumn" (click)="sortData('AgreementReference')">
                      <a class="sort text-dark" data-sort>Contract</a>
                    </th>
                    <th class="input">
                      <input class="form-check-input list-checkbox-all" type="checkbox" name="all" [checked]="isAllChecked()" (change)="checkAll($event)"/>
                    </th>
                    <th class="location">Location</th>
                    @if (!showSlowMovers || showWasteStream) {
                      <th class="description text-center sortableColumn" (click)="sortData('WasteType')">
                        <a class="sort text-dark" data-sort>Waste Stream</a>
                      </th>
                    }
                    @if (!showSlowMovers) {
                      <th class="description2 text-center"></th>
                    }
                    @if (!showSlowMovers) {
                      <th class="default text-center">Contract Type</th>
                    }
                    @if (showSlowMovers && !showWasteStream) {
                      <th class="description text-center">Account Manager</th>
                    }
                    @if (showSlowMovers && !showLatestActionDate) {
                      <th class="default text-center">Account Code</th>
                    }
                    @if (showSlowMovers && showLatestActionDate) {
                      <th class="default text-center sortableColumn" (click)="sortData('LatestDate')">
                        <a class="sort text-dark" data-sort>Latest Date</a>
                      </th>
                    }
                    @if (showSlowMovers && showAccountCategory && !showLatestActionDescription) {
                      <th class="description2 text-center">Account Category</th>
                    }
                    @if (showSlowMovers && !showAccountCategory && !showLatestActionDescription && !showAccountType) {
                      <th class="description text-center">Customer Name</th>
                    }
                    @if (showSlowMovers && !showAccountCategory && !showLatestActionDescription && showAccountType) {
                      <th class="description text-center">Account Type</th>
                    }
                    @if (showSlowMovers && showLatestActionDate) {
                      <th class="description2 text-center sortableColumn" (click)="sortData('LatestAction')">
                        <a class="sort text-dark" data-sort>Latest Action</a>
                      </th>
                    }
                    <th class="type text-center">Container Type</th>
                    <th class="asset text-center sortableColumn" (click)="sortData('ContainersOnSite')">
                      <a class="sort text-dark" data-sort>Containers On Site</a>
                    </th>
                    <th class="count text-center sortableColumn" (click)="sortData('TimeOnSite')">
                      <a class="sort text-dark" data-sort>Time On Site (days)</a>
                    </th>
                    <th class="avg text-center sortableColumn" (click)="sortData('ServiceFrequency')">
                      <a class="sort text-dark" data-sort>Service Frequency (days)</a>
                    </th>
                    <th class="qty text-center">Qty</th>
                    <th class="amount text-center">Rental</th>
                  </tr>
                </thead>
                <tbody class="here">
                  @for (agreement of data.agreements.items; track agreement; let ind = $index; let isOdd = $odd) {
                    <ng-container class="py-2">
                      @if (!agreement?.containers?.length) {
                        <tr id="ind + 1" [ngClass]="{'odd': isOdd}">
                          <td class="default">
                            @if (agreement.reference) {
                              <div class="innerWrapper row">
                                <div (click)="toggleRow(agreement.reference)" class="controls col-2">@if (!expandedAgreements.includes(agreement.reference)) {
                                  <i class="material-icons">add</i>
                                  }@if (expandedAgreements.includes(agreement.reference)) {
                                  <i class="material-icons">remove</i>
                                }</div>
                                <span title="{{ agreement.reference }}" class="reference col-10">{{ agreement.reference + (agreement.hasNotes ? " ✎" : "") }}</span>
                              </div>
                            }
                          </td>
                          <td class="input">
                            @if (agreement.reference) {
                              <input class="form-check-input list-checkbox-all" type="checkbox" name="chkAgreement" [value]="agreement.reference" [checked]="agreement.checked" (change)="agreement.checked = !agreement.checked" />
                            }
                          </td>
                          <td class="location"><span>{{ agreement.locationName }}</span></td>
                          <td class="description text-center">
                            @if (!showSlowMovers) {
                              <span>
                                {{ agreement.wasteTypeName }}
                              </span>
                            }
                            @if (showSlowMovers) {
                              <span>
                                {{ agreement.accountManager }}
                              </span>
                            }
                          </td>
                          <td class="default text-center">
                            @if (showSlowMovers) {
                              <span>{{ agreement.accountCode }}</span>
                            }
                          </td>
                          <td class="description2 text-center">
                            @if (!showSlowMovers) {
                              <span>
                                {{ agreement.assetTypeName }}
                              </span>
                            }
                            @if (showSlowMovers && showAccountCategory) {
                              <span>
                                {{ agreement.accountCategory }}
                              </span>
                            }
                            @if (showSlowMovers && !showAccountCategory && !showAccountType) {
                              <span>
                                {{ agreement.customerName }}
                              </span>
                            }
                            @if (showSlowMovers && !showAccountCategory && showAccountType) {
                              <span>
                                {{ agreement.accountType }}
                              </span>
                            }
                          </td>
                          <td class="type text-center"></td>
                          <td class="asset text-center"></td>
                          <td class="count text-center"></td>
                          <td class="avg text-center"><span>{{ agreement.serviceFrequencyDisplay }}</span></td>
                          <td class="qty text-center"><span>{{ agreement.qty}}</span></td>
                          <td class="amount text-center"><span>{{ agreement.rentalTotalDisplay }}</span></td>
                        </tr>
                      }
                      @for (container of agreement.containers; track container; let i = $index) {
                        <tr [ngClass]="{'odd': isOdd}">
                          @if (i == 0) {
                            <td class="default" [attr.rowspan]="agreement.containers.length > 1 && i == 0 ? agreement.containers.length : ''">
                              @if (i == 0 && agreement.reference) {
                                <div class="innerWrapper row">
                                  <div (click)="toggleRow(agreement.reference)" class="controls col-2">@if (!expandedAgreements.includes(agreement.reference)) {
                                    <i class="material-icons">add</i>
                                    }@if (expandedAgreements.includes(agreement.reference)) {
                                    <i class="material-icons">remove</i>
                                  }</div>
                                  <span title="{{ agreement.reference }}" class="reference col-10">{{ agreement.reference + (agreement.hasNotes ? " ✎" : "") }}</span>
                                </div>
                              }
                            </td>
                          }
                          @if (i == 0) {
                            <td class="input" [attr.rowspan]="agreement.containers.length > 1 && i == 0 ? agreement.containers.length : ''">
                              @if (i == 0) {
                                <input class="form-check-input list-checkbox-all" type="checkbox" name="chkAgreement" [value]="agreement.reference" [checked]="agreement.checked" (change)="agreement.checked = !agreement.checked" />
                              }
                            </td>
                          }
                          @if (i == 0) {
                            <td class="location" [attr.rowspan]="agreement.containers.length > 1 && i == 0 ? agreement.containers.length : ''">
                              @if (i == 0) {
                                <span>
                                  {{ agreement.locationName }}
                                </span>
                              }
                            </td>
                          }
                          @if (i == 0) {
                            <td class="description text-center" [attr.rowspan]="agreement.containers.length > 1 && i == 0 ? agreement.containers.length : ''">
                              @if (i == 0 && (!showSlowMovers || showWasteStream)) {
                                <span>
                                  {{ agreement.wasteTypeName }}
                                </span>
                              }
                              @if (i == 0 && showSlowMovers && !showWasteStream) {
                                <span>
                                  {{ agreement.accountManager }}
                                </span>
                              }
                            </td>
                          }
                          @if (i == 0) {
                            <td class="default text-center" [attr.rowspan]="agreement.containers.length > 1 && i == 0 ? agreement.containers.length : ''">
                              @if (i == 0 && showSlowMovers && !showLatestActionDate) {
                                <span>
                                  {{ agreement.accountCode }}
                                </span>
                              }
                              @if (i == 0 && showSlowMovers && showLatestActionDate) {
                                <span class="{{ getLatestActionStyle(agreement) }}">
                                  {{ agreement.latestActionDateDisplay }}
                                </span>
                              }
                            </td>
                          }
                          @if (i == 0) {
                            <td class="description2 text-center" [attr.rowspan]="agreement.containers.length > 1 && i == 0 ? agreement.containers.length : ''">
                              @if (i == 0 && !showSlowMovers) {
                                <span>
                                  {{ agreement.assetTypeName }}
                                </span>
                              }
                              @if (i == 0 && showSlowMovers && showAccountCategory && !showLatestActionDescription) {
                                <span>
                                  {{ agreement.accountCategory }}
                                </span>
                              }
                              @if (i == 0 && showSlowMovers && !showAccountCategory && !showLatestActionDescription && !showAccountType) {
                                <span>
                                  {{ agreement.customerName }}
                                </span>
                              }
                              @if (i == 0 && showSlowMovers && !showAccountCategory && !showLatestActionDescription && showAccountType) {
                                <span>
                                  {{ agreement.accountType }}
                                </span>
                              }
                              @if (i == 0 && showSlowMovers && showLatestActionDescription) {
                                <span class="{{ getLatestActionStyle(agreement) }}">
                                  {{ agreement.latestActionDescription }}
                                </span>
                              }
                            </td>
                          }
                          <td id="container-type" class="type text-center" class="{{ getAssignmentStatusStyle(container) }}" [title]="getAssignmentStatusDescription(container)">
                            {{ container.assetTypeName }}
                          </td>
                          <td class="asset text-center" class="{{ getAssignmentStatusStyle(container) }}" [title]="getAssignmentStatusDescription(container)">
                            <a href="/showposition/{{ agreement.locationId }}/{{ container.name }}" target = "_blank">{{ container.name }}</a>
                          </td>
                          <td class="count text-center" class="{{ getAssignmentStatusStyle(container) }}" [title]="getAssignmentStatusDescription(container)">
                            {{ !container.name ? "" : container.daysOnSiteDisplay }}
                          </td>
                          @if (i == 0) {
                            <td class="avg text-center" [title]="getAssignmentStatusDescription(container)" [attr.rowspan]="agreement.containers.length > 1 && i == 0 ? agreement.containers.length : ''">
                              @if (i == 0) {
                                <span>{{ agreement.serviceFrequencyDisplay }}</span>
                              }
                            </td>
                          }
                          @if (i == 0) {
                            <td class="qty text-center" [attr.rowspan]="agreement.containers.length > 1 && i == 0 ? agreement.containers.length : ''">
                              @if (i == 0) {
                                <span>{{ agreement.qty}}</span>
                              }
                            </td>
                          }
                          @if (i == 0) {
                            <td class="amount text-center" [attr.rowspan]="agreement.containers.length > 1 && i == 0 ? agreement.containers.length : ''">
                              @if (i == 0) {
                                <span>{{ agreement.rentalTotalDisplay }}</span>
                              }
                            </td>
                          }
                          <td></td>
                        </tr>
                      }
                      @if (expandedAgreements.includes(agreement.reference)) {
                        <tr [ngClass]="{'odd': isOdd}">
                          <td><button class="btn btn-purple btn-sm shadow-light-sm btn-size" (click)="editContactDetails(agreement.reference)">Contact</button></td>
                          <td></td>
                          <td class="notes">{{ getContactDetails(agreement) }}</td>
                          <td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td>
                        </tr>
                        <tr [ngClass]="{'odd': isOdd}">
                          <td><button class="btn btn-purple btn-sm shadow-light-sm btn-size" (click)="editNotes(agreement.reference)">Notes</button></td>
                          <td></td>
                          <td class="notes">{{ getNotes(agreement) }}</td>
                          <td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td>
                        </tr>
                        <tr [ngClass]="{'odd': isOdd}">
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td>
                        </tr>
                        <tr [ngClass]="{'odd': isOdd}">
                          <th class="detail"></th>
                          <th class="detail"></th>
                          <th class="detail text-center"><span>Account Manager</span></th>
                          <th class="detail text-right">Contract History:</th>
                          <th class="detail text-center">Created</th>
                          <th class="title detail"></th>
                          <th class="subheader detail"></th>
                          <th class="subheader detail"></th>
                          <th class="subheader detail"></th>
                          <th class="detail"></th>
                          <th class="detail"></th>
                          <th class="detail"></th>
                          <th class="exp"></th>
                        </tr>
                        <tr [ngClass]="{'odd': isOdd}">
                          <td></td>
                          <td></td>
                          <td class="detail text-center">{{ agreement.accountManager }}</td>
                          <td></td>
                          <td class="text-center">{{ agreement.startDate | date:'dd/MM/yyyy' }}</td>
                          <td></td>
                          <td class="type"></td>
                          <td class="asset"></td>
                          <td class="count"></td>
                          <td></td><td></td><td></td><td></td>
                        </tr>
                        <tr [ngClass]="{'odd': isOdd}"><th class="detail" colspan="13"></th></tr>
                        <tr [ngClass]="{'odd': isOdd}">
                          <th class="detail"></th>
                          <th class="detail"></th>
                          <th class="detail text-center"><span>Customer Name</span></th>
                          <th class="title detail text-right">Service History:</th>
                          <th class="subheader detail text-center">Date</th>
                          <th class="subheader detail text-center">Container In</th>
                          <th class="subheader detail text-center">Container Out</th>
                          <th class="subheader detail text-center">Job Type</th>
                          @if (isAdmin && showAdminOptions) {
                            <th class="subheader detail text-center">Other Contract</th>
                          }
                          <th class="subheader detail text-center">Days On Site</th>
                          @if (!isAdmin || !showAdminOptions) {
                            <th class="detail"></th>
                          }
                          <th class="detail"></th>
                          <th class="detail"></th>
                          <td class="exp"></td>
                        </tr>
                        <tr [ngClass]="{'odd': isOdd}">
                          <td></td>
                          <td></td>
                          <td class="description text-center">{{ agreement.customerName }}</td>
                          <td></td>
                          <td></td>
                          <td class="dummy">-</td>
                          <td class="dummy">-</td>
                          <td class="dummy">-</td>
                          <td class="dummy">-</td>
                          <td></td><td></td><td></td><td></td>
                        </tr>
                        @for (assignment of agreement.retrievedAssignments; track assignment) {
                          <tr [ngClass]="{'odd': isOdd}" [hidden]="!agreement.retrievedAssignments">
                            <td></td><td></td><td></td><td></td>
                            <td class="type text-center">{{ assignment.startDate | date:'dd/MM/yyyy' }}</td>
                            <td class="asset text-center">{{ assignment.containerIn }}</td>
                            <td class="asset text-center">{{ assignment.containerOut }}</td>
                            <td class="asset text-center">{{ assignment.jobTypeNameDisplay }}</td>
                            @if (isAdmin && showAdminOptions) {
                              <td class="asset text-center">{{ assignment.otherReference }}</td>
                            }
                            <td class="count text-center">{{ assignment.daysOnSiteDisplay }}</td>
                            @if (!isAdmin || !showAdminOptions) {
                              <td></td>
                              }<td></td> <td></td><td></td>
                            </tr>
                          }
                          <tr [ngClass]="{'odd': isOdd}"><th class="detail" colspan="13"></th></tr>
                        }
                      </ng-container>
                    }
                  </tbody>
                  <tfoot>
                    <tr>
                      <th colspan="13" class="py-0">
                        <table style="width: 100%;">
                          <tr>
                            <th class="text-center">
                              <span class="footer">Total Contracts: {{ data.totalAgreements }}</span>
                            </th>
                            <th class="text-center"><span class="footer">Matched Containers: {{ data.totalMatchedContainers }}</span></th>
                            <th class="text-center"><span class="footer">Not Matched Containers: {{ data.totalUnmatchedContainers }}</span></th>
                            <th class="text-center">
                              @if (data.isAnyRent) {
                                <span class="footer">Rental (Total): {{ data.totalRentDisplay }}</span>
                              }
                            </th>
                            <th class="text-center">
                              @if (data.isAnyRent) {
                                <span class="footer">Rental (This Week): {{ data.thisWeekRentDisplay }}</span>
                              }
                            </th>
                            <th>
                              @if (agreementsSelected() && selectedDepotId && selectedDepotId != '00000000-0000-0000-0000-000000000000') {
                                <button class="btn btn-purple btn-sm shadow-light-sm" (click)="applyRental()">Apply Rental</button>
                              }
                            </th>
                            <th>
                              @if (agreementsSelected() && data?.isAnyRent && selectedDepotId && selectedDepotId != '00000000-0000-0000-0000-000000000000') {
                                <button class="btn btn-purple btn-sm shadow-light-sm" (click)="removeRental()">Remove Rental</button>
                              }
                            </th>
                            <th>
                              @if (agreementsSelected()) {
                                <button class="btn btn-purple btn-sm shadow-light-sm" (click)="applyActions()">Contract Actioned</button>
                              }
                            </th>
                            <th>
                              @if (agreementsSelected()) {
                                <button class="btn btn-purple btn-sm shadow-light-sm" (click)="manualReset()">Manual Reset</button>
                              }
                            </th>
                          </tr>
                        </table>
                      </th>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
